import { NgClass } from '@angular/common';
import { Component, computed, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BREAKPOINT_LG, BREAKPOINT_MD, BREAKPOINT_SM, BREAKPOINT_XL, DashboardLayoutDimensions, DashboardLayoutService } from '../../services';
import { IconContext } from './interfaces';


@Component({
	selector: 'icon-text',
	standalone: true,
	imports: [NgClass],
	templateUrl: './icon-text.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./icon-text.widget.scss'],
})
export class IconTextWidget implements OnInit {

	public layoutService = inject(DashboardLayoutService);


	public iconContext = input.required<IconContext>();



	/**
	* Determines whether the part should make room
	* to display text to the right of the icon.
	*/
	public hidingText = computed(() => {
		const dimensions = this.layoutService.dimensions();
		return this.checkForHideText(dimensions);
	});



	ngOnInit() {
		this.checkForHideText(this.layoutService.dimensions());
	}



	checkForHideText(d: DashboardLayoutDimensions) {

		if (!d || !this.iconContext()) {
			return false;
		}
		else {
			const hideText = this.iconContext().hideText || 'never';

			return !this.iconContext().text ||
				(hideText == 'always') ||
				(hideText == 'lt-xl' && d.windowWidth < BREAKPOINT_XL) ||
				(hideText == 'lt-lg' && d.windowWidth < BREAKPOINT_LG) ||
				(hideText == 'lt-md' && d.windowWidth < BREAKPOINT_MD) ||
				(hideText == 'lt-sm' && d.windowWidth < BREAKPOINT_SM);
		}
	}

}